// Vendor Libs
import {omit} from 'lodash';

// Private
const initialOverlayState = {};

const actions = {
    OVERLAY_OPEN: (state, {config}) => ({...state, [config.id]: config}),

    OVERLAY_CLOSE: (state, {id}) => omit(state, [id]),

    OVERLAY_CLOSE_ALL: state => initialOverlayState,

    AUTHENTICATE_LOGOUT: state => initialOverlayState,
};

const reducer = (state = initialOverlayState, action) =>
    actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
